import { z } from 'zod'

import { InvoiceLineColumnValues } from '@features/invoices/types/invoiceLineColumn'

export const getInvoiceColumnVisibilityFormSchema = () => {
  return z.object({
    selectedColumns: z.array(z.enum(InvoiceLineColumnValues)),
  })
}
